<template>
  <TagList :tags="parsedTags" :canUpdate="true" @click="handleClick" />
</template>

<script setup>
import { computed } from "vue";
import { TagList } from "@/Components/Tags";

const emit = defineEmits(["createNewTag", "toggleTagSelected"]);

const props = defineProps({
  tags: { type: Array, default: () => [] },
  activeTagIds: { type: Array, default: () => [] },
});

const parsedTags = computed(() => {
  return props.tags
    .map((tag) => {
      return {
        ...tag,
        active: isActive(tag.id),
      };
    })
    .sort((a, b) => {
      if (a.id === "new_tag") {
        return -1;
      }
      if (b.id === "new_tag") {
        return 1;
      }
      return a.name.localeCompare(b.name);
    });
});

function isActive(tagId) {
  return props.activeTagIds.includes(tagId);
}

function handleClick(tagId) {
  if (tagId === "new_tag") {
    emit("createNewTag");
    return;
  }
  emit("toggleTagSelected", tagId);
}
</script>
